export default {
  label: {
    notes: 'Label of export csv action in visualisation',
    message: 'Export',
  },
};
